/* custom-winactie-reviews.js — Trustpilot-band van de winactiepagina (sections/custom-winactie-reviews.liquid, 14-10-2026).
 * Alles hier is progressieve verbetering: zonder dit script staan er volledige reviews in een veegbare rail.
 *
 * 1. "Lees meer". De CSS kort titel (1 regel) en tekst (3 regels) al in vóór de eerste paint (`.js` op <html>), zodat de
 *    band niet krimpt als dit script (defer) draait. Hier wordt per kaart gemeten of er echt iets wegvalt; alleen dan
 *    verschijnt de knop (in de voetregel, dus zonder hoogteverschil). Hermeten na het laden van de webfonts en bij resize.
 *
 * 2. Beweging op elke breedte (Jory 14-10: ook op mobiel), van rechts naar links, 30 px/s. Zelfde mechaniek als de UGC-band
 *    van de bureau-PDP (custom-bureau-v2.js): elke kaart krijgt een eigen, oneindige transform-animatie over één cyclus W
 *    (alle kaarten + tussenruimtes) met een fase-offset, zodat hij op t = 0 precies op zijn layoutplek staat en eens per
 *    cyclus links buiten beeld terugspringt naar rechts buiten beeld. Geen DOM-rotatie: geen layoutverschuiving, vaste
 *    Tab-volgorde, elke review één keer voor een schermlezer. Start pas als de band in beeld is, en alleen als het
 *    terugspringpunt (W − stap) buiten de rail ligt.
 *    Stopt bij: buiten beeld, hover (echte muisbeweging), toetsenbordfocus in de band, tik/klik op de rail, de verborgen
 *    stopknop, een uitgeklapte review en "minder beweging" (ook als die tijdens het bezoek aangaat). WCAG 2.2.2.
 *    Mobiel blijft de rail veegbaar: een horizontale veeg zet de band tijdelijk stil; 4 s na de laatste aanraking loopt hij
 *    verder vanaf waar de bezoeker gebleven is.
 */
(function () {
  'use strict';

  var SNELHEID = 30; /* px/s, gelijk aan de bureau-PDP */

  function initLeesMeer(band) {
    var paren = [];
    [].forEach.call(band.querySelectorAll('[data-wa-reviews-kaart]'), function (kaart) {
      var knop = kaart.querySelector('[data-wa-review-meer]');
      var delen = [].slice.call(kaart.querySelectorAll('[data-wa-review-kort]'));
      if (!knop || !delen.length) return;
      paren.push({ kaart: kaart, knop: knop, delen: delen });
      knop.addEventListener('click', function () {
        var open = kaart.getAttribute('data-open') !== 'true';
        kaart.setAttribute('data-open', String(open));
        knop.setAttribute('aria-expanded', String(open));
        knop.textContent = open ? knop.getAttribute('data-minder') : knop.getAttribute('data-meer');
      });
    });
    if (!paren.length) return;
    function meten() {
      paren.forEach(function (p) {
        if (p.kaart.getAttribute('data-open') === 'true') return; /* uitgeklapt blijft uitgeklapt */
        p.knop.hidden = !p.delen.some(function (el) { return el.scrollHeight > el.clientHeight + 1; });
      });
    }
    meten();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(meten).catch(function () {});
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(meten, 150); });
  }

  function initBeweging(band) {
    var rail = band.querySelector('[data-wa-reviews-rail]');
    var groep = rail && rail.querySelector('[data-wa-reviews-groep]');
    if (!groep || groep.children.length < 2) return;
    if (typeof groep.animate !== 'function' || !('IntersectionObserver' in window)) return;

    var mqGroot = window.matchMedia('(min-width: 990px)');
    var mqRustig = window.matchMedia('(prefers-reduced-motion: reduce)');
    var knop = band.querySelector('[data-wa-beweging-stop]');
    var status = band.querySelector('[data-wa-beweging-status]');
    var railLabel = rail.getAttribute('aria-label');
    /* gebruiker = stopknop of tik/klik (blijvend) · hover = muis · focus = toetsenbord · open = een uitgeklapte review ·
       veeg = vinger veegt de rail (< 990, tijdelijk: loopt VEEG_PAUZE ms na de laatste aanraking/scroll weer). */
    var st = { gebruiker: false, hover: false, focus: false, open: false, veeg: false, zichtbaar: false };
    var VEEG_PAUZE = 4000;
    var anims = null, stapNu = 0, laatste = null, neer = null, klok = null, vingers = 0, begin = null;

    function gap() { return parseFloat(getComputedStyle(groep).columnGap) || 0; }
    function stap() { return groep.children[0].getBoundingClientRect().width + gap(); }
    function past() {
      /* Het terugspringpunt (W − stap) moet buiten de rail liggen, anders springt er een kaart midden in beeld. */
      return stap() * (groep.children.length - 1) >= rail.clientWidth;
    }
    function magLopen() {
      return st.zichtbaar && !st.gebruiker && !st.hover && !st.focus && !st.open && !st.veeg && !mqRustig.matches && past();
    }

    function bouw() {
      var kaarten = [].slice.call(groep.children);
      var s = stap(), W = s * kaarten.length;
      stapNu = s;
      band.classList.add('st-wa-reviews--auto');
      /* ≥ 990 is de rail niet zelf scrollbaar (pijltjestoetsen doen niets); < 990 blijft hij veegbaar en scrollbaar. */
      if (mqGroot.matches) rail.setAttribute('aria-label', 'Klantreviews');
      if (knop) knop.hidden = false;
      /* Kaart i (layoutpositie L = i·stap) loopt van W − stap − L naar −stap − L; iterationStart 1 − (L + stap) / W geeft op
         t = 0 exact transform 0. Zelfde tijdlijn voor allemaal, dus pauzeren houdt de onderlinge afstand exact. */
      anims = kaarten.map(function (k, i) {
        var L = i * s;
        return k.animate(
          [{ transform: 'translateX(' + (W - s - L) + 'px)' }, { transform: 'translateX(' + (-s - L) + 'px)' }],
          { duration: (W / SNELHEID) * 1000, iterations: Infinity, iterationStart: 1 - (L + s) / W, easing: 'linear' }
        );
      });
    }
    function afbreken() {
      if (anims) anims.forEach(function (a) { a.cancel(); });
      anims = null;
      band.classList.remove('st-wa-reviews--auto');
      rail.setAttribute('aria-label', railLabel);
      rail.scrollLeft = 0;
      if (knop) knop.hidden = true;
    }
    /* < 990: wat de bezoeker zelf heeft geveegd (scrollLeft s) wordt looptijd. Alle kaarten schuiven s px verder (s / snelheid
       seconden) en de scroll gaat in dezelfde frame terug naar 0: hetzelfde beeld, maar de cyclus klopt weer (zelfde aanpak als
       de UGC-band van de bureau-PDP, veegOmzetten). */
    function veegOmzetten() {
      var s = rail.scrollLeft;
      if (anims === null || s < 1) return;
      var dt = s / SNELHEID * 1000;
      anims.forEach(function (a) { a.currentTime = (a.currentTime || 0) + dt; });
      rail.scrollLeft = 0;
    }
    function bijwerken() {
      if (!past()) { if (anims) afbreken(); return; }
      if (magLopen()) {
        if (anims === null) bouw();
        else if (anims[0].playState === 'paused') { veegOmzetten(); anims.forEach(function (a) { a.play(); }); }
      } else if (anims !== null && anims[0].playState === 'running') {
        anims.forEach(function (a) { a.pause(); });
      }
    }

    function zetGebruiker(w) {
      st.gebruiker = w;
      if (knop) {
        knop.textContent = knop.getAttribute(w ? 'data-label-hervat' : 'data-label-stop');
        if (status) status.textContent = knop.getAttribute(w ? 'data-status-stil' : 'data-status-loopt');
      }
      bijwerken();
    }
    if (knop) knop.addEventListener('click', function () { zetGebruiker(!st.gebruiker); });

    /* Een uitgeklapte review leest niet prettig terwijl hij wegschuift: zolang er één open staat, staat de band stil. Staat de
       kaart half buiten beeld (getikt aan de rand), dan schuift de band hem in 250 ms helemaal in beeld. */
    band.addEventListener('click', function (e) {
      var knopMeer = e.target.closest && e.target.closest('[data-wa-review-meer]');
      if (!knopMeer) return;
      st.open = !!band.querySelector('[data-wa-reviews-kaart][data-open="true"]');
      bijwerken();
      var kaart = knopMeer.closest('[data-wa-reviews-kaart]');
      if (kaart && kaart.getAttribute('data-open') === 'true') inBeeld(kaart);
    });
    function inBeeld(kaart) {
      var r = kaart.getBoundingClientRect(), rr = rail.getBoundingClientRect(), marge = 12, dx = 0;
      if (r.left < rr.left + marge) dx = r.left - (rr.left + marge); /* < 0: kaarten naar rechts */
      else if (r.right > rr.right - marge) dx = r.right - (rr.right - marge); /* > 0: naar links */
      if (Math.abs(dx) < 1) return;
      if (!anims) { rail.scrollBy({ left: dx, behavior: mqRustig.matches ? 'auto' : 'smooth' }); return; }
      /* Bewegende stand: de tijdlijn verschuiven (+dx px = +dx / snelheid s). Nooit onder 0 (vóór de start tekent een animatie
         zonder fill niets): dan eerst een hele cyclus erbij, dat is hetzelfde beeld. */
      var cyclus = anims[0].effect.getTiming().duration;
      var van = anims[0].currentTime || 0, naar = van + dx / SNELHEID * 1000, t0 = null;
      if (naar < 0) { van += cyclus; naar += cyclus; }
      requestAnimationFrame(function stapje(ts) {
        if (t0 === null) t0 = ts;
        var f = Math.min(1, (ts - t0) / 250); f = 1 - Math.pow(1 - f, 3);
        anims.forEach(function (a) { a.currentTime = van + (naar - van) * f; });
        if (f < 1 && anims) requestAnimationFrame(stapje);
      });
    }

    /* Hover: alleen bij echte muisbeweging (een stilstaande cursor waar de band onderdoor schuift telt niet). */
    rail.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (!laatste) { laatste = { x: e.clientX, y: e.clientY }; return; }
      if (Math.abs(e.clientX - laatste.x) < 2 && Math.abs(e.clientY - laatste.y) < 2) return;
      laatste = { x: e.clientX, y: e.clientY };
      if (!st.hover) { st.hover = true; bijwerken(); }
    });
    rail.addEventListener('pointerleave', function () { laatste = null; if (st.hover) { st.hover = false; bijwerken(); } });

    /* Vegen (touch): alleen een echte horizontale veeg (> 8 px en meer horizontaal dan verticaal) zet de band tijdelijk stil;
       verticaal over de band heen scrollen niet. De klok loopt pas als er geen vinger meer op de rail ligt en begint bij elk
       scroll-event (uitrollen) opnieuw. Touch-events, want pointer-events stoppen bij het begin van een pan (h225). */
    function klokAls() {
      if (!st.veeg || vingers) return;
      clearTimeout(klok);
      klok = setTimeout(function () { klok = null; if (st.veeg && !vingers) { st.veeg = false; bijwerken(); } }, VEEG_PAUZE);
    }
    function tel(e) { vingers = [].filter.call(e.touches || [], function (t) { return rail.contains(t.target); }).length; }
    rail.addEventListener('touchstart', function (e) {
      tel(e); clearTimeout(klok);
      var t = e.touches && e.touches[0];
      begin = t ? { x: t.clientX, y: t.clientY } : null;
    }, { passive: true });
    rail.addEventListener('touchmove', function (e) {
      var t = e.touches && e.touches[0];
      if (!t || !begin || st.veeg) return;
      var dx = Math.abs(t.clientX - begin.x), dy = Math.abs(t.clientY - begin.y);
      if (dx > 8 && dx > dy) { clearTimeout(klok); st.veeg = true; bijwerken(); }
    }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (n) {
      rail.addEventListener(n, function (e) { tel(e); begin = null; klokAls(); }, { passive: true });
    });
    rail.addEventListener('scroll', klokAls, { passive: true });

    /* Tik/klik op de rail zet de band blijvend stil of weer aan; een tik op een knop of link doet dat niet. Na een veeg komt er
       geen pointerup (pointercancel), dus een veeg is nooit een tik. */
    rail.addEventListener('pointerdown', function (e) { neer = (e.button === 0 || e.button === undefined) ? { x: e.clientX, y: e.clientY, t: Date.now() } : null; });
    rail.addEventListener('pointercancel', function () { neer = null; });
    rail.addEventListener('pointerup', function (e) {
      var n = neer; neer = null;
      if (!n || !anims) return;
      if (e.target.closest && e.target.closest('a, button')) return;
      if (Math.abs(e.clientX - n.x) < 12 && Math.abs(e.clientY - n.y) < 12 && Date.now() - n.t < 500) {
        if (st.veeg) { st.veeg = false; clearTimeout(klok); }
        zetGebruiker(!st.gebruiker);
      }
    });

    /* Toetsenbordfocus in de band (niet de stopknop zelf): stil, en alle kaarten terug op hun layoutplek (t = 0), zodat de
       browser de kaart met focus zelf in beeld schuift. Bij een muisklik of tik (geen :focus-visible) verschuift er niets. */
    function toetsFocus(el) {
      if (!el || el === knop || !band.contains(el)) return false;
      try { return el.matches(':focus-visible'); } catch (x) { return true; }
    }
    band.addEventListener('focusin', function (e) {
      var b = toetsFocus(e.target);
      if (b && anims) { rail.scrollLeft = 0; anims.forEach(function (a) { a.pause(); a.currentTime = 0; }); }
      if (st.focus !== b) { st.focus = b; bijwerken(); }
    });
    band.addEventListener('focusout', function () {
      setTimeout(function () {
        var b = toetsFocus(document.activeElement);
        if (!b && mqGroot.matches) rail.scrollLeft = 0; /* ≥ 990 rekent de cyclus vanaf scrollpositie 0; < 990 doet veegOmzetten dat */
        if (st.focus !== b) { st.focus = b; bijwerken(); }
      }, 0);
    });

    /* Over 990 wisselen kaartmaat en tussenruimte: de cyclus opnieuw opbouwen (vanaf de layoutposities). */
    function wissel() { if (anims) afbreken(); bijwerken(); }
    [mqRustig, mqGroot].forEach(function (mq) {
      if (mq.addEventListener) mq.addEventListener('change', wissel); else if (mq.addListener) mq.addListener(wissel);
    });
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (anims && Math.abs(stap() - stapNu) >= 0.5) { afbreken(); }
        bijwerken();
      }, 150);
    });

    new IntersectionObserver(function (e) {
      st.zichtbaar = e[e.length - 1].isIntersecting; /* de laatste entry is de meest recente waarneming */
      bijwerken();
    }, { threshold: 0.05 }).observe(rail);
  }

  function init(root) {
    [].forEach.call((root || document).querySelectorAll('[data-wa-reviews]'), function (band) {
      if (band.hasAttribute('data-wa-klaar')) return;
      band.setAttribute('data-wa-klaar', '');
      initLeesMeer(band);
      initBeweging(band);
    });
  }

  init();
  /* Theme-editor: een opnieuw geladen sectie krijgt nieuwe elementen. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
